import { render, staticRenderFns } from "./TriviaCount.vue?vue&type=template&id=3d011c0c&scoped=true&"
import script from "./TriviaCount.vue?vue&type=script&lang=js&"
export * from "./TriviaCount.vue?vue&type=script&lang=js&"
import style0 from "./TriviaCount.vue?vue&type=style&index=0&id=3d011c0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d011c0c",
  null
  
)

export default component.exports